import React from 'react';
import { Modal } from 'antd';
import styled from '@emotion/styled';
import { CloseCircleOutlined } from '@ant-design/icons';
import { TitleModal } from '../../../molecules/modal/TitleModal';
import { FormThreshold } from '../forms/FormThreshold';
import { appStyles, selectSelector } from '../../../../styles';

interface ModalThresholdInputProps {
  isOpenModal: boolean;
  title: string;
  content: string;
  placeholder: string;
  onSubmit: (value: string) => void;
  onClose: () => void;
}

export const ModalThresholdInput = (props: ModalThresholdInputProps) => {
  const { isOpenModal, title, content, placeholder, onSubmit, onClose } = props;

  return (
    <StyledModal
      title={<TitleModal title={title} />}
      centered
      visible={isOpenModal}
      width={630}
      footer={null}
      onCancel={() => {
        onClose();
      }}
      maskClosable={false}
      closeIcon={<CloseCircleOutlined />}
      forceRender
    >
      <FormThreshold onSubmit={onSubmit} content={content} placeholder={placeholder} />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  & > .ant-modal-content {
    ${appStyles.commonModalContentStyle}
  }

  .ant-modal-header {
    padding-left: 0;
  }

  .btn-wrap {
    text-align: center;
  }

  .btn-generate-code {
    width: 270px;
    margin: 2rem;
  }

  .ant-form-item-label {
    font-weight: bold;
  }

  .form-content {
    padding: 1.5rem 1.5rem 3.5rem;
  }

  .btn-submit-generate-access-code,
  .btn-submit-export-access-code {
    position: absolute;
    bottom: 1rem;
    right: 3rem;
  }

  & input[type='text'],
  & input[type='number'] {
    ${appStyles.inputStyle}
  }

  .ant-select-selector {
    height: 36px !important;
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      padding: 2px 18px 2px 0;
    }
  }

  .ant-input-number {
    width: 100%;
  }

  .ant-input-number-handler-wrap {
    display: none;
  }

  ${selectSelector}
`;
